import classNames from 'classnames'
import style from './tabs.module.scss'
import { Tab, Tabs } from 'react-bootstrap'
import useGetCashinCashout from 'pages/fund/financialHistory/hooks/useGetCashinCashout'
import DotsLoading from 'components/loadings/dotsLoading'
import CashinCashout from './cashinCashout'
import useGetLoans from 'pages/fund/financialHistory/hooks/useGetLoans'
import { useCallback } from 'react'
import Loans from './loans'
import posthog from 'posthog-js'

export default function CustomTabs() {
    const { cashinData, isLoadingCashin } = useGetCashinCashout()
    const { loans, isLoadingLoans, fetchNextPage } = useGetLoans()

    const onWatchEnd = useCallback(() => {
        fetchNextPage?.()
    }, [fetchNextPage])

    return (
        <div className=" bg-white mt-2">
            <Tabs
                defaultActiveKey="profile"
                id="member-financial-tabs"
                onSelect={(key) => {
                    posthog.capture('member_financial_tab_changed', {
                        tab: key === 'profile' ? 'transactions' : 'loans',
                    })
                }}
                className={classNames(
                    'mb-0.5 min-h-10 border-b border-[#EFEFEF]',
                    '[&_.nav-link]:!text-black [&_.nav-link]:!font-normal [&_.nav-link]:!border-0 [&_.nav-link]:!text-sm [&_.nav-link]:!min-h-10 [&_.nav-link]:!flex [&_.nav-link]:!items-center [&_.nav-link]:!justify-center',
                    '[&_.nav-link.active]:!text-black [&_.nav-link.active]:!font-normal [&_.nav-link.active]:!border-b-2 [&_.nav-link.active]:!border-green-1',
                    style.myTabs
                )}
                fill
                variant="underline"
            >
                <Tab
                    eventKey="profile"
                    title={`تراکنش‌ها${
                        cashinData?.result?.length
                            ? ` (${cashinData.result.length})`
                            : ''
                    }`}
                >
                    <div className=" mt-0.5">
                        {isLoadingCashin ? (
                            <DotsLoading />
                        ) : cashinData && cashinData?.result?.length > 0 ? (
                            <CashinCashout data={cashinData.result} />
                        ) : (
                            <p className=" text-center text-sm text-text-secondary px-4 py-8">
                                هنوز تراکنشی برای این عضو ثبت نشده است
                            </p>
                        )}
                    </div>
                </Tab>
                <Tab
                    eventKey="home"
                    title={`وام‌ها (${loans?.pages[0]?.count || 0})`}
                >
                    <div className=" mt-0.5">
                        {isLoadingLoans ? (
                            <DotsLoading />
                        ) : loans && loans?.pages?.length > 0 ? (
                            <Loans data={loans} onWatchEnd={onWatchEnd} />
                        ) : (
                            <p className=" text-center text-sm text-text-secondary px-4 py-8">
                                هنوز وامی برای این عضو ثبت نشده است
                            </p>
                        )}
                    </div>
                </Tab>
            </Tabs>
        </div>
    )
}
